module.exports = function() {
  return new Worker(__webpack_public_path__ + "fe9e92e956db6f2830f5.worker.js");
};